// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D-3H","rootNoMargin":"styles_rootNoMargin__t2DY2"};